const DISPLAY_NAME_OVERRIDES: Record<string, string> = {
  "3-Wheelers": "Tuk Tuk",
};

export function formatCategoryName(name: string): string {
  return DISPLAY_NAME_OVERRIDES[name] ?? name;
}
